import Symbol2d from '../2d.js'

export default class CurvedArrow extends Symbol2d {

  onHandleChange (handle, diff, handles, dimensions) {
    // reset the properties
    this.properties = this.getProperties(dimensions, handles.map(h => h.coords))
  }

  onDimensionsChange(dimensions, handles) {
    const radius = this.properties.radius
    if (dimensions.diff.width) {
      // Width is changing, adjust the tip height
      this.properties.tipHeight += dimensions.diff.height * this.properties.tipHeight

      if (dimensions.height > dimensions.width) {
        // When the height is greater than the width, we want to scale the properties
        this.properties.radius += dimensions.diff.width * radius
        this.properties.tipWidth += dimensions.diff.width * this.properties.tipWidth
        this.properties.tipHeight += dimensions.diff.width * this.properties.tipHeight
      }
    }

    if (dimensions.diff.height && dimensions.height < dimensions.width) {
      // Height is changing and the width is greater than the height
      this.properties.radius += dimensions.diff.height * radius
      this.properties.tipWidth += dimensions.diff.height * this.properties.tipWidth
      this.properties.tipHeight += dimensions.diff.height * this.properties.tipHeight
    }

    this.updateHandles(handles, dimensions)
  }

  getComponents (data, dimensions) {
    const handles = this.getHandles(dimensions)

    // Set the tip height
    if (!this.properties) {
      // Initial render
      this.properties = this.getProperties(dimensions, handles.map(h => h.coords))
    }

    const paths = this.getPaths(data, dimensions, handles.map(handle => handle.coords))

    return {
      handles,
      flattenedPaths: paths.length > 1 ? this.getFlattenedPaths(data, dimensions) : paths,
      paths
    }
  }

  getHandles (dimensions) {
    let handles = this._getDefaultHandles()

    // The 2nd handle that controls the box width `y` value will always be
    // equal to the first value `y`, which controls the arrow width.
    handles[1].coords[1] = handles[0].coords[1]
    return [
      handles[0],
      handles[1]
    ].map(handle => this.enforceConstraints(handle, dimensions, handles))
  }

}
